import { get } from './';

export const getCurrencies = () => get('api/v1/currencies');
